module.exports = __webpack_public_path__ + "img/118.a25c56da.jpg";